
import { defineComponent } from 'vue'
import NavSection from "./NavSection.vue";
import NameHeading from "./NameHeading.vue";

export default defineComponent({
    name: "HeaderSection",

    components:{
        NavSection,
        NameHeading
    },

    data(){
        return{
            // Auto Scroll Animation Settings
            scrollDuration: 1250, // in ms
            framerate: 60, // FPS, max 100 - JS can't handle more (timing issue)

            // Auto Scroll Variables
            isAutoScrolling: false,
            topPage: true,
            scrollPos: 0,

            // Other
            startY: 0,
            pageScrollVal: 0,
            isMounted: false
        }
    },

    mounted(){

        this.isMounted = true;
        
        window.addEventListener("scroll", this.preventUserScroll, { passive: false });

        window.addEventListener('touchstart', (e) => {
            this.startY = e.touches[0].clientY;
        });

        window.addEventListener('touchmove', this.touchScrollThrottle, { passive: false });

    },

    methods:{

            /* Page Scroll */

        preventUserScroll(e: Event){

            this.pageScrollVal = window.scrollY as number;

            // Don't allow user scrolling during the auto scroll
            this.autoScrollDirection();

            if (window.scrollY <= window.innerHeight){
                e.preventDefault();
            }

        },

        touchScrollThrottle(e: TouchEvent){

            if (!this.isAutoScrolling && window.scrollY <= window.innerHeight){

                // Prevent default scrolling
                e.preventDefault();

                // Calculate the touch scroll delta
                const currentY = e.touches[0].clientY;
                const deltaY = this.startY - currentY;

                // Adjust the page's scroll position
                window.scrollBy(0, deltaY);

                // Update startY
                this.startY = currentY;

            }

        },

            /* Auto Scroll */

        autoScrollDirection(){
            // Current scroll position
            const currPos = window.scrollY;

            // Check the scroll direction
            const scrollDir = this.scrollPos > currPos ? "up" : "down";
            this.autoScroll(scrollDir);

            // Set the scroll position to the current one to compare it later
            this.scrollPos = currPos;
        },

        preventScroll(e: Event){
            e.preventDefault();
        },

        enableScrolling(){
            document.documentElement.classList.remove("no-scroll");
            window.removeEventListener('scroll', this.preventScroll);
            window.removeEventListener('touchmove', this.preventScroll);
        },

        preventScrolling(){
            document.documentElement.classList.add("no-scroll");
            window.addEventListener('scroll', this.preventScroll, { passive: false });
            window.addEventListener('touchmove', this.preventScroll, { passive: false });
        },

        isTopPage(direction: string){
            if (direction === "down"){
                this.topPage = false;
            } else if (direction === "up" && 
                window.scrollY <= window.innerHeight){
                this.topPage = true;
            }
        },

        autoScroll(direction: string){

                /* Execution Conditions */
    
            // Do not execute the code while auto scrolling
            // And check the direction conditions
            if (this.isAutoScrolling ||
                !this.topPage && direction === "down" ||
                this.topPage && direction === "up" || 
                window.scrollY >= window.innerHeight - 50 && direction === "up"){
                return;
            }

            // Do not execute the code when a nav-link was clicked
            if (document.body.classList.contains("nav-link-clicked")){
                this.topPage = false;
                return;
            }

                /* Settings */

            // Disable scrolling
            this.preventScrolling();

            this.isAutoScrolling = true;

            // Check if the page is at the top position
            this.isTopPage(direction);

            // Scroll start/end position
            const startPosition = window.scrollY;
            const endPosition = direction === "down" ? window.innerHeight : 0;
            const scrollRange = endPosition - startPosition;
            
            // Frames
            const totalFrames = (this.scrollDuration / 1000) * this.framerate;
            const frameInterval = 1000 / this.framerate;

            // Easing (slower end of the animation)
            const easing = (t: number) => 1 - (1 - t) * (1 - t);
            let i = 0;

                /* Scroll Animation */

            const animateScroll = () => {

                if (i > totalFrames) {
                    // Enable scrolling after the animation
                    this.enableScrolling();

                    // Set the animation as finished
                    this.isAutoScrolling = false;
                    return; 
                }

                // Update the scroll position
                const scrollTo = startPosition + scrollRange * easing(i / totalFrames);

                window.scrollTo({
                    top: scrollTo
                });
                
                i++;
                setTimeout(() => {
                    requestAnimationFrame(animateScroll);
                }, frameInterval)

            };

            // Start the animation
            requestAnimationFrame(animateScroll);
        }

    }

});
